export const redirectToLogout = () => {
  if (window.location.pathname === '/logout') return;
  window.location.assign('/logout');
};
